import {Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ServicioImagenesService} from '../../../services/servicio-imagenes.service';

import {AfiliadoEntity, EntregaMedicamentosEntity, EntregaMedicamentosService} from '../../../services/entrega-medicamentos.service';
import {EntidadEmpresarialEntity, ServicioEntidadService} from '../../../services/servicio-entidad.service';
import {HttpErrorResponse} from '@angular/common/http';
import {EntidadEmpresarial} from '../../../services/servicio-comprobante-informe.service';
import {ServicioCaptacionService} from '../../../services/servicio-captacion.service';

@Component({
  selector: 'app-reporte-entrega-medicamentos',
  templateUrl: './reporte-entrega-medicamentos.component.html',
  styleUrls: ['./reporte-entrega-medicamentos.component.css']
})

export class ReporteEntregaMedicamentosComponent implements OnInit {

  constructor(
    private entregaMedicamentosService: EntregaMedicamentosService,
    private servicioCaptacionService: ServicioCaptacionService,
    private servicioImagenes: ServicioImagenesService,
    private servicioEntidad: ServicioEntidadService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.params.subscribe( (params: any) => {
      this.codigoBaseDatos = params.codigoBaseDatos;
      this.uncoSede = params.uncoSede;
      this.uncoLogin = params.uncoLogin;
    });
  }
  public data: any;
  public valorTotal: any;
  public valor: any;
  public fechaImpresion: Date = new Date();
  public uncoTransaccion: string;
  public tipoDocumento: string;
  public dataReporte: any;
  public dataEntidadEmpresarial: EntidadEmpresarial = {
    identificacionTributaria: '',
    digitoVerificacion: '',
    descripcion: '',
    direccion: '',
    telefono: '',
    logoUrl: '',
    codigoPrestador: ''
  };

  private uncoSede: number;
  private uncoLogin: number;

  private isLoadingRequest: boolean;

  private entidadEmpresarial: EntidadEmpresarialEntity;

  // publicas
  afiliado: AfiliadoEntity;

  mensajeLoading: string;
  mensajeError: string;
  codigoBaseDatos: string;
  logo: string;
  nombreUsuario: string;

  dataEntregaMedicamentosEntity: EntregaMedicamentosEntity[] = [];

  /* Consumir Servicio */

  ngOnInit() {

    this.getInfoEntidadEmpresarial().then(() => {this.isLoadingRequest = false; });
    this.getInfoUsuario().then(() => {this.isLoadingRequest = false; });
  }

  private async getInfoEntidadEmpresarial() {

    this.isLoadingRequest = true;

    try {

      this.mensajeLoading = 'Cargando información entidad ...';
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.codigoBaseDatos, this.uncoSede);
      response.subscribe((data: EntidadEmpresarialEntity[]) => {
        if (data && data.length > 0) {
          this.entidadEmpresarial = data[0];
          this.getLogoReporte();
          this.mensajeLoading = null;
          this.mensajeError = null;
        } else {
          // Error grave al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteEntregaMedicamentosComponent.getInfoEntidadEmpresarial()', err);
        // Error grave al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.
      });
    } catch (e) {
      console.error('ReporteEntregaMedicamentosComponent.getInfoEntidadEmpresarial()', e);
      // Error grave al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.
    }
  }

  private async getInfoUsuario() {

    this.isLoadingRequest = true;

    (await this.entregaMedicamentosService.getInformacionUsuario(this.codigoBaseDatos, this.uncoLogin)).subscribe((data: any) => {
      if (data != null) {
        this.nombreUsuario = data[0].nombreUsuario;
      }
    }, error => {
      console.error(error);
    });
  }

  private async getEntregaMedicamentosData(paramsOfFilterSelected: any) {

    this.isLoadingRequest = true;
    this.mensajeLoading = 'Cargando entrega de medicamentos ...';

    try {

      this.afiliado = paramsOfFilterSelected.afiliado;

      (await this.entregaMedicamentosService.getEntregaMedicamentosData(this.codigoBaseDatos, paramsOfFilterSelected.fechaIni,
        paramsOfFilterSelected.fechaFin, paramsOfFilterSelected.afiliado.unco, paramsOfFilterSelected.orden))
        .subscribe((dataEntregaMedicamentosEntity: EntregaMedicamentosEntity[]) => {
          if (dataEntregaMedicamentosEntity && dataEntregaMedicamentosEntity.length > 0) {
            this.mensajeLoading = null;
            this.mensajeError = null;
            this.dataEntregaMedicamentosEntity = dataEntregaMedicamentosEntity;
          }
        }, (err: HttpErrorResponse) => {
          console.error('Error ReporteEntregaMedicamentosComponent.getEntregaMedicamentosData()', err);
        });
    } catch (e) {
      console.error('ReporteEntregaMedicamentosComponent.getEntregaMedicamentosData()', e);
    }
  }

  private async getLogoReporte() {

    (await this.servicioCaptacionService.getLogoEntidadEmpresarial(this.codigoBaseDatos, this.entidadEmpresarial.unco)).subscribe((data: any) => {
      this.logo = data.source;
    }, error => {
      console.error('ReporteEntregaMedicamentosComponent.getLogoReporte()', error);
    });
  }

  onFiltrosCompletados($event: any) {
    this.getEntregaMedicamentosData($event).then(() => {this.isLoadingRequest = false; });
  }

  onErrorGenerado(error: string) {
    this.mensajeError = error;
  }

  afilialoSeleccionado($event: any) {
    this.afiliado = $event;
  }

  isLoading(): boolean {
    return this.isLoadingRequest;
  }

  isError(): boolean {
    return this.mensajeError && this.mensajeError.length > 0;
  }
}
